import React, { useEffect } from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import { 
  FinancialReport, 
  MonthlyRevenue,
  CorporateGovernance,
  InstitutionalInvestorsConference,
  InvestorService,
  MajorNews,
  ShareholdersMeetingBoardInformation,
  Stakeholder,
  StockPrice
} from '../components/investor'

import useScreen from '../hooks/use-screen'

const InvestorPage = ({ pageContext }) => {
  const {
    lang,
    pageData,
    sitePrefix,
    siteTitle = 'DURO TIRE',
    navRoutes,
    activeCat,
  } = pageContext

  const screen = useScreen()

  const aside = {
    cat: 'investor',
    menu: navRoutes.filter(d => d.slug === 'investor')[0].subMenu,
    sitePrefix,
  }

  useEffect(() => {
    if (activeCat === 'investor') {
      window.location.replace(`${sitePrefix}/investor/${aside.menu[0].slug}`)
    }
  }, [])

  return (
    <Layout
      aside={aside}
      {...pageContext}
    >
      <SEO title={siteTitle} lang={lang} />
      {activeCat === 'financial-report' && <FinancialReport screen={screen} pageData={pageData} activeCat={activeCat} />}
      {activeCat === 'monthly-revenue' && <MonthlyRevenue screen={screen} pageData={pageData} activeCat={activeCat} />}
      {activeCat === 'corporate-governance' && <CorporateGovernance screen={screen} pageData={pageData} activeCat={activeCat} />}
      {activeCat === 'institutional-investors-conference' && <InstitutionalInvestorsConference screen={screen} pageData={pageData} activeCat={activeCat} />}
      {activeCat === 'investor-service' && <InvestorService screen={screen} pageData={pageData} activeCat={activeCat} />}
      {activeCat === 'major-news' && <MajorNews screen={screen} pageData={pageData} activeCat={activeCat} />}
      {activeCat === 'shareholders-meeting-board-information' && <ShareholdersMeetingBoardInformation screen={screen} pageData={pageData} activeCat={activeCat} />}
      {activeCat === 'stakeholder' && <Stakeholder screen={screen} pageData={pageData} activeCat={activeCat} />}
      {activeCat === 'stock-price' && <StockPrice screen={screen} pageData={pageData} activeCat={activeCat} />}
    </Layout>
  )
}

export default InvestorPage
